import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from '@tanstack/react-router';
import Sidebar from '../sidebar/sidebar';
import Navbar from '../navbar/navbar';
import { SidebarProvider, useSidebar } from '../../context/SidebarContext';
import PageLoader from '../common/PageLoader';
import { AnimatePresence } from 'framer-motion';

const MainContent = () => {
  const { isSidebarOpen } = useSidebar();
  const [isPageLoading, setIsPageLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsPageLoading(true);
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  return (
    <div className="flex min-h-screen w-full overflow-x-hidden overflow-y-hidden bg-[#FFFFFF] font-inter">
      <Navbar />
      <Sidebar />
      <main className={`flex-1 min-h-screen w-full pt-[49px] overflow-y-auto transition-all duration-300 ${
        !isSidebarOpen ? 'pl-[72px]' : ''
      }`}>
        <AnimatePresence>
          {isPageLoading && <PageLoader />}
        </AnimatePresence>
        <Outlet />
      </main>
    </div>
  );
};

const MainLayout = () => {
  return (
    <SidebarProvider>
      <MainContent />
    </SidebarProvider>
  );
};

export default MainLayout; 